import React, {useState, useRef, useEffect} from 'react';
import PrimaryNavigation from 'components/navigation/PrimaryNavigation';
import Philosophy from 'components/sections/Philosophy';
import Tribes from 'components/sections/Tribes';
import Donate from 'components/sections/Donate';
import Footer from 'components/Footer';
import TribesModal from 'components/modal/TribesModal';
import TribesResultModal from 'components/modal/TribesResultModal';


// import { Fade, Bounce } from "react-awesome-reveal";

function App() {
  const scrollToDonate = useRef(null)
  const [page, setPage] = useState(0);
  const [result, setResult] = useState("");
  const [showTribesModal, setTribesModal] = useState(false);
  const [showTribesResultModal, setTribesResultModal] = useState(false);

  useEffect(()=>{
    setTimeout(()=>{
      if (!localStorage.getItem('visited')) {
        setTribesModal(true);
        localStorage.setItem('visited', true);
      }
    }, 2000)
  }, [])
  
  return (
    <div className="max-w-[1536px] block mx-auto">
      <div id="landingPage" >
        <PrimaryNavigation />
        <Philosophy />
        <Tribes setTribesModal={setTribesModal} setTribesResultModal={setTribesResultModal} setResult={setResult} />
        <Donate scrollToDonate={scrollToDonate}/>
        <Footer />
        <TribesModal show={showTribesModal} close={() => setTribesModal(false)} setTribesResultModal={setTribesResultModal} setResult={setResult} setPage={setPage} page={page} />
        <TribesResultModal show={showTribesResultModal} close={() => setTribesResultModal(false)} result={result} setPage={setPage} page={page} scrollToDonate={scrollToDonate} />
      </div>
    </div>
    

  );
}

export default App;

